/**
 * @file: SamplingCheckResultType.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum SamplingCheckResultType {
  None = 0,
  Passed = 1,
  Failed = 2,
}

export const SamplingCheckResultTypeValueSet = new Set([
  SamplingCheckResultType.None,
  SamplingCheckResultType.Passed,
  SamplingCheckResultType.Failed,
]);
